import React, { useState } from "react";
import { Button, IconButton, Tooltip } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import translate from "../../i18n/translate";
import { connect } from "react-redux";
import ApiRequest from "../../actions/ApiRequest";
import Notiflix from "notiflix";

const SetHomePageButton = ({ 
  user, 
  currentPath, 
  pageName,
  variant = "icon", // "icon", "button", "text"
  size = "small",
  className = ""
}) => {
  const [loading, setLoading] = useState(false);
  const [isHomePage, setIsHomePage] = useState(
    user?.start_page === currentPath || user?.default_page === currentPath
  );
  
  // Update isHomePage state when user data changes
  React.useEffect(() => {
    setIsHomePage(user?.start_page === currentPath || user?.default_page === currentPath);
  }, [user?.start_page, user?.default_page, currentPath]);

  const handleSetHomePage = async () => {
    try {
      setLoading(true);
      
      console.log(`🏠 Setting start page to: ${currentPath}`);
      
      const response = await ApiRequest.post(
        `update_seller_profile?operation=profile&start_page=${encodeURIComponent(currentPath)}&seller_id=${user?.id}`
      );

      console.log('📥 Set home page response:', response.data);

      if (response.data.status === "success") {
        setIsHomePage(true);
        Notiflix.Notify.success(
          translate("Start page updated successfully!"),
          "",
          "Close"
        );
        
        // Update user data in localStorage
        const updatedUser = { ...user, start_page: currentPath };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        localStorage.setItem("companies", JSON.stringify(updatedUser));
      } else {
        throw new Error(response.data.reason || "Failed to update");
      }
    } catch (error) {
      Notiflix.Notify.failure(
        error.message || translate("Failed to update start page"),
        "",
        "Close"
      );
      console.error("❌ Error setting start page:", error);
    } finally {
      setLoading(false);
    }
  };

  if (variant === "icon") {
    return (
      <Tooltip 
        title={
          isHomePage 
            ? translate("This is your home page")
            : translate("Set as home page")
        }
      >
        <IconButton
          onClick={handleSetHomePage}
          disabled={loading || isHomePage}
          size={size}
          className={className}
          sx={{
            color: isHomePage ? "#4CAF50" : "inherit",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "scale(1.1)",
              color: "#4CAF50",
            },
          }}
        >
          {isHomePage ? <CheckCircleIcon /> : <HomeIcon />}
        </IconButton>
      </Tooltip>
    );
  }

  if (variant === "text") {
    return (
      <Button
        onClick={handleSetHomePage}
        disabled={loading || isHomePage}
        size={size}
        className={className}
        startIcon={isHomePage ? <CheckCircleIcon /> : <HomeIcon />}
        sx={{
          textTransform: "none",
          color: isHomePage ? "#4CAF50" : "inherit",
        }}
      >
        {isHomePage
          ? translate("Current Home Page")
          : translate("Set as Home Page")}
      </Button>
    );
  }

  return (
    <Button
      onClick={handleSetHomePage}
      disabled={loading || isHomePage}
      variant="outlined"
      size={size}
      className={className}
      startIcon={isHomePage ? <CheckCircleIcon /> : <HomeIcon />}
      sx={{
        textTransform: "none",
        borderColor: isHomePage ? "#4CAF50" : "inherit",
        color: isHomePage ? "#4CAF50" : "inherit",
        "&:hover": {
          borderColor: "#4CAF50",
          backgroundColor: "rgba(76, 175, 80, 0.04)",
        },
      }}
    >
      {isHomePage
        ? translate("Current Home Page")
        : translate("Set as Home Page")}
    </Button>
  );
};

const mapStateToProps = ({ auth: { user } }) => ({
  user,
});

export default connect(mapStateToProps)(SetHomePageButton);

